import React from 'react';
import { Reveal } from './Reveal';
import { FACTS } from '../data/facts';
export function FactsStrip() {
  return <section aria-label="Production facts" className="border-y border-led/10 bg-ink px-5 py-8 sm:px-8 lg:px-12" data-id="element-78" data-mp="244eomrh6gkbq">
      <Reveal data-id="element-79" data-mp="1q56o9v9a365y">
        <div className="mx-auto flex max-w-[1800px] flex-wrap items-center justify-center divide-x divide-led/15 text-center" data-id="element-80" data-mp="1q5f0rm1ho9gm">
          {FACTS.map(fact => <span key={fact} className="px-5 py-1 text-[11px] uppercase tracking-[0.2em] text-led/70 sm:px-8 sm:text-xs" data-id="element-81" data-mp="2hvtad62gyzmh">
              {fact}
            </span>)}
        </div>
      </Reveal>
    </section>;
}